var impressum = "Declaración de propiedad y autoría";
var privacy = "Privacidad y legal";
var recallInfo = "Recuperar información";
var signOut = "Cerrar sesión";
var es_es = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { es_es as default, impressum, privacy, recallInfo, signOut };
